<template>
    <Dialog :show="show" :has-backdrop="true" width="550px">
        <div :style="{display: 'flex', flexFlow:'column'}">
            <h4>Warnung</h4>

            <div>Leider bist du noch nicht als User angelegt worden.</div>
            <br>
            <div>Damit das Deal Monitoring Tool reibungslos funktioniert, ist es notwendig, dass jeder User im Tool
                hinterlegt ist.
            </div>
            <br>
            <div>Bitte wende dich an <a
                :href="'mailto:marleen.koeller@ad-alliance.de'+mailString('marleen.wegert@ad-alliance.de')"
                style="color:#00b6ed; text-decoration: none;">Marleen
                Wegert</a>
                oder <a :href="'mailto:daniel.peter@ad-alliance.de'+mailString('daniel.peter@ad-alliance.de')"
                        style="color:#00b6ed; text-decoration: none;">Daniel
                    Peter</a>, damit sie
                dich anlegen können.
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from "../../components/dialogs/Dialog";

export default {
    name: "NoUserFound",
    props: ['show'],
    components: {Dialog},
    data: () => ({
        admins: [
            "marleen.koeller@ad-alliance.de",
            "daniel.peter@ad-alliance.de"
        ]
    }),
    methods: {
        mailString(email) {
            let emails = this.admins.filter(x => x !== email);

            let body = 'Liebe DMT Admins,\n\n könntet ihr mich als User im DMT anlegen?\n\n Vielen Dank und liebe Grüße';
            return '?subject=DMT - Neuen User anlegen&body=' + encodeURIComponent(body) + '&cc=' + emails.join(',');
        }
    },
}
</script>

<style scoped>

</style>